<template>
  <div>
    <el-dialog
      :destroy-on-close="true"
      :visible.sync="dialogVisible"
      title="还原回收学员"
      append-to-body
      @close="handleDialogClose"
    >
      <div class="dialog-content-wrap">
        <div class="dialog-title">
          <p class="title">还原分配</p>
          <p class="desp">
            (已选择<span class="mwow-green">{{ studentIds.length }}</span
            >人)
          </p>
        </div>
        <div class="main-form">
          <el-form size="mini" :model="courseTeacherInfo">
            <el-form-item label="">
              <div style="margin-bottom: 16px">
                <el-radio v-model="courseTeacherInfo.join_potential" label="1">
                  <div class="radio-wrap">
                    <p class="p1">课程顾问</p>
                    <p class="p2">
                      将回收学员还原至意向学员，重新分配课程顾问跟进
                    </p>
                  </div>
                </el-radio>
              </div>
              <div>
                <el-radio v-model="courseTeacherInfo.join_potential" label="2">
                  <div class="radio-wrap">
                    <p class="p1">公海池</p>
                    <p class="p2">
                      将回收学员还原至意向学员并同步到公海池，可被其他课程顾问看见并认领
                    </p>
                  </div>
                </el-radio>
              </div>
            </el-form-item>
            <el-form-item
              label="（选填）课程顾问:"
              prop="follow_staff_id"
              label-width="114px"
              v-if="courseTeacherInfo.join_potential === '1'"
            >
              <el-select
                v-model.number="courseTeacherInfo.follow_staff_id"
                clearable
                filterable
                placeholder="请选择"
                :filter-method="handleChangeFollowStaff"
              >
                <el-option
                  v-for="item in followStaffList"
                  :key="item.staff_id"
                  :label="item.name"
                  :value="item.staff_id"
                ></el-option>
              </el-select>
              <p style="color: #999; font-size: 12px">
                选择课程顾问后，会分配归属该课程顾问并推送公众号提醒消息
              </p>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="form-btn">
        <div class="mwow-button-filled" @click="dialogVisible = false">
          取消
        </div>
        <div class="mwow-button-filled success" @click="handleDialogConfirm">
          确定
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { recycleStudentrecoverApi } from "@/api/studentManage";
import { staffList } from "@/api/globalSearch";
export default {
  props: ["student-ids", "visible"],
  data() {
    return {
      dialogVisible: false,
      courseTeacherInfo: {
        join_potential: "",
        follow_staff_id: "",
      },
      followStaffList: [],
    };
  },
  watch: {
    visible(n) {
      this.dialogVisible = n;
      this.handleChangeFollowStaff("");
    },
  },
  methods: {
    handleDialogConfirm() {
      if (this.courseTeacherInfo.join_potential === "") {
        this.$message({
          type: "warning",
          message: "请先选择分配方式",
        });
        return false;
      }
      let params = {
        student_ids: this.studentIds,
        join_potential: this.courseTeacherInfo.join_potential === "2",
      };
      if (
        this.courseTeacherInfo.join_potential === "1" &&
        this.courseTeacherInfo.follow_staff_id
      ) {
        params.follow_staff_id = Number(this.courseTeacherInfo.follow_staff_id);
      }
      recycleStudentrecoverApi(params).then(() => {
        this.$message({
          type: "success",
          message:
            "还原成功" +
            (this.courseTeacherInfo.join_potential === "1"
              ? "意向学员"
              : "公海池"),
        });
        this.dialogVisible = false;
      });
    },
    handleDialogClose() {
      this.courseTeacherInfo = {
        join_potential: "",
        follow_staff_id: "",
      };
      this.$emit("update:visible", false);
      this.$emit("close");
    },
    handleChangeFollowStaff(v) {
      staffList({
        page: 1,
        page_size: 50,
        key_word: v,
        job_ids: [3],
        status: 1,
      }).then((res) => {
        this.followStaffList = res.data.list;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.dialog-content-wrap {
  display: flex;
  .dialog-title {
    width: 100px;
    .title {
      font-size: 16px;
      line-height: 16px;
      color: #5c5d5e;
      margin-bottom: 12px;
      font-weight: bold;
    }
    .desp {
      font-size: 12px;
      line-height: 12px;
    }
  }
  .main-form {
    flex: 1;
    .radio-wrap {
      display: inline-block;
      vertical-align: middle;
      .p1 {
        font-size: 14px;
        line-height: 14px;
        margin-bottom: 8px;
        color: #5c5d5e;
        font-weight: bold;
      }
      .p2 {
        font-size: 12px;
        line-height: 12px;
        color: #999;
      }
    }
  }
}
.form-btn {
  display: flex;
  justify-content: end;
  :nth-child(1) {
    margin-right: 10px;
  }
}
</style>
